/**
 * Fix & Flip Calculation Engine 
 *
 * P4  = purchasePrice + SUM(purchaseCostItems)
 * P5  = holdingMonths × SUM(holdingCostItems)
 * P6  = SUM(rehabTransactions)
 * P10 = SUM(sellingCostItems)
 * M13 = P4 + P5 + P6 + P10
 * M21 = salePrice − M13
 * M25 = M21 / M13
 */

export function computeFlip(inputs, rehabTransactions = [], purchaseCostItems = [], holdingCostItems = [], sellingCostItems = []) {
  const { purchasePrice = 0, holdingMonths = 0, salePrice = 0 } = inputs

  const purchaseItemsTotal = purchaseCostItems.reduce((s, i) => s + (parseFloat(i.amount) || 0), 0)
  const purchaseCostTotal  = purchasePrice + purchaseItemsTotal          // P4

  const monthlyHoldingCost = holdingCostItems.reduce((s, i) => s + (parseFloat(i.amount) || 0), 0)
  const holdingCostTotal   = holdingMonths * monthlyHoldingCost          // P5

  const rehabCostTotal     = rehabTransactions.reduce((s, t) => s + (parseFloat(t.amount) || 0), 0) // P6

  const sellingCostTotal   = sellingCostItems.reduce((s, i) => s + (parseFloat(i.amount) || 0), 0)  // P10

  const totalCosts   = purchaseCostTotal + holdingCostTotal + rehabCostTotal + sellingCostTotal // M13
  const totalProfit  = salePrice - totalCosts                            // M21
  const profitMargin = totalCosts  > 0 ? totalProfit / totalCosts  : 0  // M25

  const cashInvested   = purchaseCostTotal + holdingCostTotal + rehabCostTotal
  const roi            = cashInvested > 0 ? totalProfit / cashInvested : 0
  const equityMultiple = cashInvested > 0 ? salePrice   / cashInvested : 0

  return {
    purchaseCostTotal, purchaseItemsTotal,
    monthlyHoldingCost, holdingCostTotal,
    rehabCostTotal,
    sellingCostTotal,
    totalCosts, salePrice,
    totalProfit, profitMargin,
    roi, equityMultiple, cashInvested,
  }
}

// ── Default state ─────────────────────────────────────────────────────────────
export const DEFAULT_FLIP_INPUTS = {
  purchasePrice: 185000,
  holdingMonths: 6,
  salePrice:     265000,
}

export const DEFAULT_PURCHASE_ITEMS = [
  { id: 1, label: 'Inspections',  amount: 0 },
  { id: 2, label: 'Appraisals',   amount: 0 },
  { id: 3, label: 'Surveys',      amount: 0 },
  { id: 4, label: 'Lawyer Fees',  amount: 0 },
  { id: 5, label: 'Closing Cost', amount: 0 },
]

export const DEFAULT_HOLDING_ITEMS = [
  { id: 1, label: 'Mortgage Payment', amount: 0 },
  { id: 2, label: 'Property Taxes',   amount: 0 },
  { id: 3, label: 'Insurance',        amount: 0 },
  { id: 4, label: 'Water',            amount: 0 },
  { id: 5, label: 'Electric',         amount: 0 },
  { id: 6, label: 'Gas',              amount: 0 },
]

export const DEFAULT_SELLING_ITEMS = [
  { id: 1, label: 'Commissions to Agents (6%)', amount: 15900 },
  { id: 2, label: 'Buyer Home Warranty',         amount:     0 },
  { id: 3, label: 'Buyer Termite Letter',        amount:     0 },
  { id: 4, label: "Buyer's Closing Costs",       amount:     0 },
  { id: 5, label: "Seller's Closing Costs",      amount:     0 },
]

export const DEFAULT_REHAB = [
  { id: 1, date: '', costType: 'Labor',    description: 'Kitchen renovation', amount: 0 },
  { id: 2, date: '', costType: 'Material', description: 'Flooring',           amount: 0 },
  { id: 3, date: '', costType: 'Labor',    description: 'Bathroom update',    amount: 0 },
  { id: 4, date: '', costType: 'Material', description: 'Exterior paint',     amount: 0 },
]
